import { Component } from '@angular/core';
import { CTableCell } from '../../../../core/ui/c-table/c-table-config';

@Component({
  selector: 'app-team-add-member-act-col',
  template: `
    <div class="btn-group" role="group">
      <button class="btn btn-primary" (click)="extraData.update(row['entity'])"><i class="fa fa-edit"></i></button>
      <button class="btn btn-danger"
              mwlConfirmationPopover
              [popoverTitle]="'Confirmation'"
              [popoverMessage]="'Are you sure?'"
              placement="left"
              (confirm)="extraData.delete(row['entity'])" ><i class="fa fa-trash"></i></button>
    </div>`
})
export class EditDeleteActColComponent implements CTableCell {
  extraData;
  row;
  column;
}
